export default __webpack_public_path__ + "static/media/HGGGothicssi.03a41619.woff2";